import _defineProperty from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  fftSize: 2048,
  maxDecibels: -30,
  minDecibels: -100,
  smoothingTimeConstant: 0.8
};
export var createAnalyserNodeConstructor = function createAnalyserNodeConstructor(audionNodeConstructor, createAnalyserNodeRenderer, createIndexSizeError, createNativeAnalyserNode, getNativeContext, isNativeOfflineAudioContext) {
  return /*#__PURE__*/function (_audionNodeConstructo) {
    _inherits(AnalyserNode, _audionNodeConstructo);

    var _super = _createSuper(AnalyserNode);

    function AnalyserNode(context, options) {
      var _this;

      _classCallCheck(this, AnalyserNode);

      var nativeContext = getNativeContext(context);

      var mergedOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

      var nativeAnalyserNode = createNativeAnalyserNode(nativeContext, mergedOptions);
      var analyserNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createAnalyserNodeRenderer() : null;
      _this = _super.call(this, context, false, nativeAnalyserNode, analyserNodeRenderer);
      _this._nativeAnalyserNode = nativeAnalyserNode;
      return _this;
    }

    _createClass(AnalyserNode, [{
      key: "fftSize",
      get: function get() {
        return this._nativeAnalyserNode.fftSize;
      },
      set: function set(value) {
        this._nativeAnalyserNode.fftSize = value;
      }
    }, {
      key: "frequencyBinCount",
      get: function get() {
        return this._nativeAnalyserNode.frequencyBinCount;
      }
    }, {
      key: "maxDecibels",
      get: function get() {
        return this._nativeAnalyserNode.maxDecibels;
      },
      set: function set(value) {
        // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
        var maxDecibels = this._nativeAnalyserNode.maxDecibels;
        this._nativeAnalyserNode.maxDecibels = value;

        if (!(value > this._nativeAnalyserNode.minDecibels)) {
          this._nativeAnalyserNode.maxDecibels = maxDecibels;
          throw createIndexSizeError();
        }
      }
    }, {
      key: "minDecibels",
      get: function get() {
        return this._nativeAnalyserNode.minDecibels;
      },
      set: function set(value) {
        // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
        var minDecibels = this._nativeAnalyserNode.minDecibels;
        this._nativeAnalyserNode.minDecibels = value;

        if (!(this._nativeAnalyserNode.maxDecibels > value)) {
          this._nativeAnalyserNode.minDecibels = minDecibels;
          throw createIndexSizeError();
        }
      }
    }, {
      key: "smoothingTimeConstant",
      get: function get() {
        return this._nativeAnalyserNode.smoothingTimeConstant;
      },
      set: function set(value) {
        this._nativeAnalyserNode.smoothingTimeConstant = value;
      }
    }, {
      key: "getByteFrequencyData",
      value: function getByteFrequencyData(array) {
        this._nativeAnalyserNode.getByteFrequencyData(array);
      }
    }, {
      key: "getByteTimeDomainData",
      value: function getByteTimeDomainData(array) {
        this._nativeAnalyserNode.getByteTimeDomainData(array);
      }
    }, {
      key: "getFloatFrequencyData",
      value: function getFloatFrequencyData(array) {
        this._nativeAnalyserNode.getFloatFrequencyData(array);
      }
    }, {
      key: "getFloatTimeDomainData",
      value: function getFloatTimeDomainData(array) {
        this._nativeAnalyserNode.getFloatTimeDomainData(array);
      }
    }]);

    return AnalyserNode;
  }(audionNodeConstructor);
};